import { render, staticRenderFns } from "./AuthorizationSection.html?vue&type=template&id=c15793da&external"
import script from "./AuthorizationSection.ts?vue&type=script&lang=ts&external"
export * from "./AuthorizationSection.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports